import * as z from 'zod';

// Company filter settings schema
export const companyFilterSettingsSchema = z.object({
  revenueType: z.enum(['gross', 'net']).optional(),
  consolidatedByYear: z.boolean().optional(),
});

export type CompanyFilterSettingsSchema = z.infer<typeof companyFilterSettingsSchema>;
